export const OldProductFamiliesConst: {
    [key: string]: string[];
} = {
    machines: [
        'virtual-machines'
    ]
};
